import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { EntityType } from '../../../entities/common';
import { ApplicationState } from '../../../store';
import { actionCreators as UserActionCreators, UserState } from '../../../store/User';
import { actionCreators as UserInterfaceActionCreators, UserInterfaceState } from '../../../store/UserInterfaceStore';
import { BaseSectionsContainerProps } from '../../common/sectionsControl/SectionsContainer/BaseSectionsContainer';
import { SectionsContainer } from '../../common/sectionsControl/SectionsContainer';
import { DETAILS_SECTION_ID, globalCalendarSections, userCalendarSections } from './CalendarSections';
import { Calendar } from '../../../store/calendar/common';

type OwnProps = Pick<BaseSectionsContainerProps, 'controlsConfig'> & {
    calendar: Calendar;
};

interface StateProps {
    user: UserState;
    userInterface: UserInterfaceState;
};

type ActionProps = {
    userActions: typeof UserActionCreators;
    userInterfaceActions: typeof UserInterfaceActionCreators;
};

type Props = OwnProps & ActionProps & StateProps & RouteComponentProps<{}>;

const CalendarSectionsContainer = (props: Props) => {
    return (
        <SectionsContainer
            {...props}
            getSections={() => props.calendar.isUserCalendar ? userCalendarSections : globalCalendarSections}
            entity={{
                ...props.calendar,
                hiddenActionsContainerIds: [DETAILS_SECTION_ID],
            }}
            entityType={EntityType.Calendar}
        />
    );
}

function mergeActionCreators(dispatch: any): ActionProps {
    return {
        userActions: bindActionCreators(UserActionCreators, dispatch),
        userInterfaceActions: bindActionCreators(UserInterfaceActionCreators, dispatch)
    };
}

function mapStateToProps(state: ApplicationState): StateProps {
    return {
        user: state.user,
        userInterface: state.userInterface
    };
}

export default withRouter<OwnProps>(connect(mapStateToProps, mergeActionCreators)(CalendarSectionsContainer));
